import { faCross, faMicrophone, faPaperPlane } from '@fortawesome/pro-regular-svg-icons';
import {faLock} from '@fortawesome/pro-solid-svg-icons';
import React from 'react';
import styled, { css } from 'styled-components';
import LoadingSpinner from '../loader';
import Hexagon from "../hexagon";

export const VOX_ICONS = {
    record: 'record',
    send: 'send',
    close: 'close',
    lock: 'lock'
}

const VOX_ICON_LIB = {
    [VOX_ICONS.record]: faMicrophone,
    [VOX_ICONS.send]: faPaperPlane,
    [VOX_ICONS.close]: faCross,
    [VOX_ICONS.lock]: faLock,
}

const ButtonContainer = styled.div`
    height: 100%;
    width: 100%;
    // margin-bottom: 10px;
    background: #F1F1F1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;

    ${props => props.canClick && css`
        >:first-child {
            cursor: pointer;
        }
    `}

    &.loading {
        >:first-child {
            cursor: wait;
        }
    }
`;
const LoaderContainer = styled.div`
    position: absolute;
    height: auto;
    width: 5rem;
    top: 0px;
    left: -17px;
    right: 0;
    bottom: 0;
`;

function VoxButton({ icon, className, processing, onClick, common }) {
    const faIcon = VOX_ICON_LIB[icon];
    return (
        <ButtonContainer className={`${className || ''} ${processing ? 'loading' : ''}`} canClick={!!onClick} onClick={evt => (processing || !onClick) ? false : onClick(evt)}>
                {processing ? (
                    <LoadingSpinner size={0.5} />
                ) : faIcon ? (
                    <Hexagon common={common} icon={faIcon} />
                ) : null}
        </ButtonContainer>
    )
}

export default VoxButton
